'use strict';

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _isIterable2 = require('babel-runtime/core-js/is-iterable');

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if ((0, _isIterable3.default)(Object(arr))) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _redux = require('redux');

function _defineProperty(obj, key, value) { if (key in obj) { (0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (scaffold) {
  var _scaffold$types = _slicedToArray(scaffold.types, 4);

  var RESET = _scaffold$types[0];
  var LOAD = _scaffold$types[1];
  var SUCCESS = _scaffold$types[2];
  var FAILURE = _scaffold$types[3];


  var data = function data() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    if (action.type === SUCCESS) {
      return _extends({}, state, _defineProperty({}, action.key || 'default', scaffold.transformData(action.data)));
    } else if (action.type === RESET) {
      return _extends({}, state, _defineProperty({}, action.key || 'default', null));
    }
    return state;
  };

  var error = function error() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    if (action.type === FAILURE) {
      return _extends({}, state, _defineProperty({}, action.key || 'default', action.data));
    } else if (action.type === SUCCESS || action.type === RESET) {
      return _extends({}, state, _defineProperty({}, action.key || 'default', null));
    }
    return state;
  };

  var loading = function loading() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    if (action.type === LOAD) {
      var _extends6;

      return _extends({}, state, (_extends6 = {}, _defineProperty(_extends6, action.key || 'default', true), _defineProperty(_extends6, 'lastKey', action.key || 'default'), _extends6));
    } else if (action.type === SUCCESS || action.type === FAILURE || action.type === RESET) {
      return _extends({}, state, _defineProperty({}, action.key || 'default', false));
    }
    return state;
  };

  var loaded = function loaded() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    if (action.type === RESET) {
      return _extends({}, state, _defineProperty({}, action.key || 'default', false));
    } else if (action.type === SUCCESS) {
      var _extends9;

      return _extends({}, state, (_extends9 = {}, _defineProperty(_extends9, action.key || 'default', true), _defineProperty(_extends9, 'lastKey', action.key || 'default'), _extends9));
    }
    return state;
  };

  return (0, _redux.combineReducers)({
    data: data,
    error: error,
    loading: loading,
    loaded: loaded
  });
};